import { render, staticRenderFns } from "./EditCardiology.vue?vue&type=template&id=d32d00c0&scoped=true"
import script from "./EditCardiology.vue?vue&type=script&lang=js"
export * from "./EditCardiology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32d00c0",
  null
  
)

export default component.exports